<template>
    <div :id="idDialog" class="modal fade" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
                <div class="modal-body p-0">
                    <div class="upload-images-container">
                        <!-- Header -->
                        <div class="upload-header">
                            <h5 class="upload-title">
                                {{ modalTitle }}
                            </h5>
                            <button type="button" class="btn-close" @click="closeModal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <!-- Content Area -->
                        <div class="upload-content">
                            <!-- Image Grid -->
                            <div v-show="activeTab === 'product'">
                                <ElUploadCustom 
                                    v-model:fileList="productImageFilesList"
                                    :upload-type="TemplateUploadImageType.product"
                                    :max-size="maxFilesizeUpload"
                                    file-extentions=".jpg,.png,"
                                    @before-image-upload="beforeImageUpload"
                                    @upload-file="(res: any, uploadType: any) => $emit('uploadFile', res, uploadType)"
                                    @handle-remove="(file: any, uploadType: any) => $emit('handleRemove', file, uploadType)"
                                    @get-image-file-type="(filename: any) => $emit('getImageFileType', filename)"
                                    @handle-remove-selected-image="(file: any, uploadType: any) => $emit('handleRemoveSelectedImage', file, uploadType)"
                                />
                            </div>

                             <!-- TODOS CREATE UI ENGRAVING LIST WITH CHECKBOX AND FETCH FROM DB, HARDCODED FIRST IF BE IS NOT READY  -->
                            <div v-show="activeTab === 'engraving'">
                                
                                <div v-loading="meshEngravingsLoading">
                                    <div v-if="meshEngravings.length === 0" class="alert alert-warning" role="alert">
                                        {{ $t('components.mesh-loader.messageNoEngravingData') }}
                                    </div>
                                    <DesignList
                                        v-if="meshEngravings.length > 0"
                                        :selected="selectedEngravingFileId"
                                        :options="meshEngravings"
                                        :multiple="true"
                                        :placeholder="$t('components.mesh-loader.engravingSearchPlaceholder')"
                                        data-type="engraving"
                                        @update:selected="handleSelectedEngraving"
                                    />
                                </div>

                                <div class="design-container"> 

                                    <!-- Engraving LR image upload field - hide temporarily -->
                                    <ElUploadCustom 
                                        v-if="false"
                                        v-model:fileList="engravingImageFilesLRList"
                                        :upload-type="TemplateUploadImageType.engravingLR"
                                        :label="$t('components.mesh-loader.engravingLR')"
                                        :tooltip-text="$t('components.mesh-loader.LRLabel')"
                                        :max-size="maxFilesizeUpload"
                                        file-extentions=".jpg,.png,"
                                        @before-image-upload="beforeImageUpload"
                                        @upload-file="(res: any, uploadType: any) => $emit('uploadFile', res, uploadType)"
                                        @handle-remove="(file: any, uploadType: any) => $emit('handleRemove', file, uploadType)"
                                        @get-image-file-type="(filename: any) => $emit('getImageFileType', filename)"
                                    />

                                    <!-- Engraving HR image upload field  -->
                                    <ElUploadCustom 
                                        v-model:fileList="engravingImageFilesHRList"
                                        :upload-type="TemplateUploadImageType.engravingHR"
                                        :label="$t('components.mesh-loader.engravingHR')"
                                        :tooltip-text="$t('components.mesh-loader.HRLabel')"
                                        :max-size="maxFilesizeUpload"
                                        file-extentions=".jpg,.png,"
                                        @before-image-upload="beforeImageUpload"
                                        @upload-file="(res: any, uploadType: any) => $emit('uploadFile', res, uploadType)"
                                        @handle-remove="(file: any, uploadType: any) => $emit('handleRemove', file, uploadType)"
                                        @get-image-file-type="(filename: any) => $emit('getImageFileType', filename)"
                                        @handle-remove-selected-image="(file: any, uploadType: any) => $emit('handleRemoveSelectedImage', file, uploadType)"
                                    />
                                </div>
                            </div>

                              <!-- TODOS CREATE UI TEXTURE LIST WITH CHECKBOX AND FETCH FROM DB, HARDCODED FIRST IF BE IS NOT READY  -->
                            <div v-show="activeTab === 'texture'">

                                <div v-loading="meshTexturesLoading">
                                    <div v-if="meshTexture.length === 0" class="alert alert-warning" role="alert">
                                        {{ $t('components.mesh-loader.messageNoTextureData') }}
                                    </div>
                                    <DesignList
                                        v-if="meshTexture.length > 0"
                                        :selected="selectedTexturesFileId"
                                        :options="meshTexture"
                                        :placeholder="$t('components.mesh-loader.textureSearchPlaceholder')"
                                        :multiple="true"
                                        data-type="texture"
                                        @update:selected="handleSelectedTextures"
                                    />
                                </div>

                                <div  class="design-container">

                                    <!-- Texture LR image upload field - hide temporarily  -->
                                    <ElUploadCustom
                                        v-if="false" 
                                        v-model:fileList="textureImageFilesLRList"
                                        :upload-type="TemplateUploadImageType.textureLR"
                                        :label="$t('components.mesh-loader.textureLR')"
                                        :tooltip-text="$t('components.mesh-loader.LRLabel')"
                                        :max-size="maxFilesizeUpload"
                                        file-extentions=".jpg,.png,"
                                        @before-image-upload="beforeImageUpload"
                                        @upload-file="(res: any, uploadType: any) => $emit('uploadFile', res, uploadType)"
                                        @handle-remove="(file: any, uploadType: any) => $emit('handleRemove', file, uploadType)"
                                        @get-image-file-type="(filename: any) => $emit('getImageFileType', filename)"
                                    />

                                    <!-- Texture HR image upload field  -->
                                    <ElUploadCustom 
                                        v-model:fileList="textureImageFilesHRList"
                                        :upload-type="TemplateUploadImageType.textureHR"
                                        :label="$t('components.mesh-loader.textureHR')"
                                        :tooltip-text="$t('components.mesh-loader.HRLabel')"
                                        :max-size="maxFilesizeUpload"
                                        file-extentions=".jpg,.png,"
                                        @before-image-upload="beforeImageUpload"
                                        @upload-file="(res: any, uploadType: any) => $emit('uploadFile', res, uploadType)"
                                        @handle-remove="(file: any, uploadType: any) => $emit('handleRemove', file, uploadType)"
                                        @get-image-file-type="(filename: any) => $emit('getImageFileType', filename)"
                                        @handle-remove-selected-image="(file: any, uploadType: any) => $emit('handleRemoveSelectedImage', file, uploadType)"
                                    />
                                </div>
                            </div>

                            <!-- TODOS ADJUST LIST COLORS FROM DB  -->
                            <div v-show="activeTab === 'color'">
                                <div class="flex gap-2 mb-4">
                                    <el-checkbox v-model="allColorsSelected" :label="$t('views.default.toggle.selectAll')" />
                                    <el-input placeholder="Search colors..." v-model="searchColor"/>
                                </div>
                                <el-scrollbar max-height="600px">
                                    <div class="gallery">
                                        <div 
                                        class="gallery-item"
                                        :class="{ selected: this.isColorSelected(color) }"
                                        v-for="color in filteredColors" :key="color.name" @click="() => handleChangeColor(color)">
                                            <div class="color" :style="{
                                                background: `rgb(${color.red},${color.green},${color.blue},${color.alpha || 1})`,
                                                }"></div>
                                                <p class="mb-0" style="font-size: small;">{{ safeT({t:$t, category:'colors', keyName:color.name}) }}</p>
                                        </div>
                                    </div>
                                </el-scrollbar>
                            </div>
                        </div>
                        <!-- Footer -->
                        <div class="upload-footer">
                        <button class="btn btn-light close-btn" @click="closeModal">
                            {{ $t('views.default.button.close') }}
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { FileData } from '@/types/enum/file';
import {  TemplateUploadImageType } from '@/types/enum/upload';
import { Modal } from 'bootstrap';
import { Component, Vue, Prop, Watch } from 'vue-facing-decorator';
import { LoadingData, MeshTreeDataWithUid, SelectedEngravingType, SelectedTextureType } from '../three/scenes/CustomMeshLoader.vue';
import PreviewRendererImg from '../features/previewRenderer/PreviewRendererImg.vue';
import { LocalColorType } from '@/types/constants/colors';
import { SupportedValues, SupportedValuesTextures } from '@/types/api/Utility/SupportedValues';
import MeshDesignSelector from '@/components/configurator/MeshDesignsSelector.vue'
import DesignList from './components/DesignList.vue';
import ElUploadCustom from '../features/uploadList/ElUploadCustom.vue';
import { safeT } from '@/utils/text';

@Component({
    components:{
        PreviewRendererImg,
        MeshDesignSelector,
        DesignList,
        ElUploadCustom
    },
     emits: [
        'beforeImageUpload',
        'uploadFile',
        'getImageFileType',
        'handleRemove',
        'update:productImageFiles',
        'update:selectedEngraving',
        'update:textureImageFilesLR',
        'update:textureImageFilesHR',
        'update:selectedTextures',
        'update:selectedColors',
        'handleRemoveSelectedImage',
        'update:selectedEngravingImagesHR',
        'update:selectedTextureImagesHR',
        'update:selectedProductImages',
        'update:engravingImageFilesHR',
        'update:selectedEngravingImagesLR',
        'update:engravingImageFilesLR',
    ],
})
export default class UploadAssetsModal extends Vue {
    @Prop({ required: true }) readonly dialog!: Modal;
    @Prop({ required: true }) readonly idDialog!: string;
    @Prop({ required: true })  productImageFiles!: FileData[];
    @Prop({ required: true })  activeTab!: string;
    @Prop({ required: true })  loadingData!: LoadingData;

    // Engraving
    @Prop({ required: true })  engravingImageFilesHR!: FileData[];
    @Prop({ required: true })  engravingImageFilesLR!: FileData[];
    @Prop({ required: true })  selectedEngravingImagesLR!: MeshTreeDataWithUid[];
    @Prop({ required: true })  selectedEngravingImagesHR!: MeshTreeDataWithUid[];

    // Texture
    @Prop({ required: true })  textureImageFilesHR!: FileData[];
    @Prop({ required: true })  textureImageFilesLR!: FileData[];
    @Prop({ required: true })  selectedTextureImagesLR!: MeshTreeDataWithUid[];
    @Prop({ required: true })  selectedTextureImagesHR!: MeshTreeDataWithUid[];

    @Prop({ default: [] }) meshColors!: LocalColorType[];
    @Prop({ required: true })  selectedColors!: LocalColorType[];
    @Prop({ required: true })  selectedEngraving!: SelectedEngravingType[];
    @Prop({ default: [] }) meshEngravings!: SupportedValues[];
    @Prop({ default: false }) meshEngravingsLoading!: boolean;
    @Prop({ default: false }) meshTexturesLoading!: boolean;
    @Prop({ required: true }) beforeImageUpload!: (file: File) => boolean;
    @Prop({ default: 1 }) maxFilesizeUpload!: number;
    @Prop({ default: [] }) meshTexture!: SupportedValuesTextures[];
    @Prop({ required: true }) selectedTextures!: SelectedTextureType[];

    TemplateUploadImageType = TemplateUploadImageType;
    searchColor = '';
    searchEngraving = '';
    safeT = safeT
    setActiveTab(tab: string) {
        this.$emit('update:activeTab', tab);
    }

    get filteredColors() {
        try {
            return this.meshColors
            .map((color) => {
                const translatedName = safeT({t:this.$t, category: 'colors', keyName:color.name})
                return { ...color, translatedName };
            })
            .filter((color) =>
                color.translatedName.toLowerCase().includes(this.searchColor.toLowerCase())
            );
        } catch (error) {
                console.error('error in filteredColors:', error);
                return this.meshColors.filter((color) =>{
                    return color.name.toLowerCase().includes(this.searchColor.toLowerCase())
                }
            )
        }
    }

    get filteredEngravings() {
        if (this.searchEngraving.length > 3) {
            const keyword = this.searchEngraving.toLowerCase();

            return this.meshEngravings.filter((engraving) => {
                const rawName = engraving.thumbnail?.name || '-';
                const translatedName = this.$t(`views.designs.${rawName}`) || rawName;

                return translatedName.toLowerCase().includes(keyword);
            });
        }

        return this.meshEngravings;
    }

    get selectedEngravingCount() {
        const count = Array.isArray(this.selectedEngraving) ? this.selectedEngraving.length : 0;
        const message = this.$t('components.create-template.engravingDesignSelected')
        const total = count + ' ' + this.$t('components.create-template.items')
        return `${message} (${total})`
    }

    closeModal() {
        this.dialog.hide();
    }

    @Watch('engravingImageFilesLR', { deep:true })
    onDesignImageFilesLRListChange() {
        this.handleNameChange();
    }

    @Watch('engravingImageFilesHR', { deep:true })
    onDesignImageFilesHRListChange() {
        this.handleNameChange();
    }

    handleNameChange(){
        const updateFilename = (files: any[], stateFiles: any[])=>{
        if(!files || !stateFiles) return
        return files.map((file: { uid: any; })=>{
            const stateFile = stateFiles.find((f: { uid: any; }) => f.uid === file.uid);
            if (!stateFile || !stateFile.raw) return file;
            const newName = stateFile.name;
            const fileType = stateFile.raw.type;
            const fileExtension = fileType?.split('/')[1] || '';
            const baseName = newName.split('.')[0];
            const hasExtension = newName.includes('.');

            const newThumbnail = hasExtension ? newName : `${baseName}.${fileExtension}`;
            return {
            ...file,
            thumbnail:newThumbnail
            }
        })
        }
        this.$emit('update:selectedEngravingImagesLR', updateFilename(this.selectedEngravingImagesLR, this.engravingImageFilesLR));
        this.$emit('update:selectedEngravingImagesHR', updateFilename(this.selectedEngravingImagesHR, this.engravingImageFilesHR));
    }

    handleChangeColor(color:LocalColorType){
        const hasSelected  = this.selectedColors.find(selectedColor=>selectedColor.name === color.name)
        const colors = hasSelected ? this.selectedColors.filter(selectedColor=>selectedColor.name !== color.name): [...this.selectedColors, color]
        this.$emit('update:selectedColors', colors);
    }

    isColorSelected(color:LocalColorType){
        const hasSelected  = this.selectedColors.find(selectedColor=>selectedColor.name === color.name)
        return Boolean(hasSelected)
    }

    get modalTitle(){
        if(this.activeTab === 'product') return this.$t('components.create-template.product-image-label') 
        if(this.activeTab === 'engraving') return this.$t('components.create-template.engraving-image-label') 
        if(this.activeTab === 'texture') return this.$t('components.create-template.texture-image-label') 
        if(this.activeTab === 'color') return this.$t('components.create-template.color-label') 
        return ''  
    }
    
    get allColorsSelected(){
        return this.meshColors.length === this.selectedColors.length
    }
    
    set allColorsSelected(value: boolean) {
        const newColors = value ? [...this.meshColors] : [];
        this.$emit('update:selectedColors', newColors);
    }

    get productImageFilesList(): FileData[] {
        return this.productImageFiles;
    }

    set productImageFilesList(val: FileData[]) {
        this.$emit('update:productImageFiles', val);
    }

    get engravingImageFilesLRList(): FileData[] {
        return this.engravingImageFilesLR;
    }

    set engravingImageFilesLRList(val: FileData[]) {
        this.$emit('update:engravingImageFilesLR', val);
    }

    get engravingImageFilesHRList(): FileData[] {
        return this.engravingImageFilesHR;
    }

    set engravingImageFilesHRList(val: FileData[]) {
        this.$emit('update:engravingImageFilesHR', val);
    }

    get textureImageFilesLRList(): FileData[] {
        return this.textureImageFilesLR;
    }

    set textureImageFilesLRList(val: FileData[]) {
        this.$emit('update:textureImageFilesLR', val);
    }

    get textureImageFilesHRList(): FileData[] {
        return this.textureImageFilesHR;
    }

    set textureImageFilesHRList(val: FileData[]) {
        this.$emit('update:textureImageFilesHR', val);
    }

    get allEngravingsSelected() {
        return this.selectedEngraving.length === this.meshEngravings.length
    }

    set allEngravingsSelected(value: boolean) {
        this.handleToggleEngravings();
    }

    extractEngravingFileIds(items: SupportedValues[]): Array<{fileId: number | null, thumbnailId: number | null}> {
        return items
            .map((item) => ({
                fileId: item.fileId,
                thumbnailId: item.thumbnail?.fileId ?? null
            }))
            .filter((item) => item.fileId !== null);
    }

    handleToggleEngravings() {
        const engravings = this.extractEngravingFileIds(this.meshEngravings);
        const newEngravings = this.allEngravingsSelected ? [] : engravings;
        this.$emit('update:selectedEngraving', newEngravings);
    }

    handleSelectedEngraving (value: SupportedValues[]) {
        if (!value && !Array.isArray(value)) return;
        const engravings = this.extractEngravingFileIds(value);
        this.$emit('update:selectedEngraving', engravings);
    }

    get selectedEngravingFileId(): number[] {
        return this.selectedEngraving
            .map(({fileId}) => fileId)
            .filter((fileId): fileId is number => fileId !== null && fileId !== undefined);
    }

    get allTexturesSelected() {
        return Array.isArray(this.selectedTextures)
            && Array.isArray(this.meshTexture)
            && this.selectedTextures.length === this.meshTexture.length;
    }

    extractTexturesFileIds(items: SupportedValues[]): Array<{fileId: number | null, thumbnailId: number | null}> {
        return items
        .map((item) => ({
                fileId: item.fileId,
                thumbnailId: item.thumbnail?.fileId ?? null
            }))
            .filter((item) => item.fileId !== null);
    }

    handleToggleTextures() {
        const textures = this.extractTexturesFileIds(this.meshTexture);
        const newTextures = this.allTexturesSelected ? [] : textures;
        this.$emit('update:selectedTextures', newTextures);
    }

    handleSelectedTextures(value: SupportedValues[]) {
        if (!Array.isArray(value)) return;
        const textures = this.extractTexturesFileIds(value);
        this.$emit('update:selectedTextures', textures);
    }

    get selectedTexturesFileId(): number[] {
        return this.selectedTextures
            .map(({fileId}) => fileId)
            .filter((fileId): fileId is number => fileId !== null && fileId !== undefined);
    }
}
</script>

<style lang="scss">
.upload-images-container{
    .el-upload-list--picture-card .el-upload-list__item{
        width: 200px !important;
        height: 200px !important;
        .preview-wrapper{
            display: flex;
            flex-direction: column;
            gap: 8px;
            width: 100%;
        
            .filename{
                padding: 4px;
            }
            span.el-upload-list__item-actions{
                height: 200px !important;
            }
        }
        .preview-wrapper > div:first-child {
            width: 100% !important;
            height: 9rem !important;

            .image{
                display: flex;
                justify-content: center;
                padding: 6px;
            }
        }
    }
    
    .el-upload--picture-card{
        width: 200px;
        height: 200px;
    }
    
    .el-checkbox__inner {
        width: 18px;
        height: 18px;
    }
    .el-checkbox__inner::after{
        top: 3px;
        left: 6px;
    }
}
</style>

<style lang="scss" scoped>
.upload-images-container {
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.form-label{
    font-size: 16px;
    width: fit-content;
    svg{
        color: #212529;
    }
}

.upload-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem 1rem 2rem;
  border-bottom: 1px solid #e9ecef;

  .upload-title {
    margin: 0;
    font-weight: 600;
    font-size: 1.25rem;
    color: #212529;
  }

  .btn-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #6c757d;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.15s ease-in-out;

    &:hover {
      background-color: #f8f9fa;
      color: #000;
    }
  }
}

.upload-content {
    padding: 2rem;
    min-height: 400px;

    .text-info{
        font-size: 16px;
        color: #ee3a3a !important;
    }

    .add-button-container {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 1rem;
        button{
            border-radius: 8px !important;
            padding: 8px 32px !important;
            height: auto;
        }
    }

    .gallery{
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 16px;
        margin: 16px 0;

        .gallery-item{
            text-align: center;
            border: 1px solid #f1f1f1;
            box-shadow: 2px 2px 2px #f1f1f1;
            padding: 12px 12px;
            border-radius: 4px;
            display: flex;
            cursor: pointer;
            flex-direction: column;
            gap: 6px;
            justify-content: center;
            align-items: center;
            img{
                border-radius: 4px;
                width: 200px;
                height: 200px;
                object-fit: cover;
            }

            .color{
                width: 60px;
                height: 60px;
                border-radius: 50%;
            }
        }
        .gallery-item.selected{
            border-color: #b20000 !important;
            border-width: 4px !important;
        }

    }

    .design-container{
        margin-top: 24px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
    .image-placeholder {
        background-color: #f8f9fa;
        border: 2px dashed #dee2e6;
        border-radius: 8px;
        display: flex;
        padding: 6px;
        cursor: pointer;
        transition: all 0.15s ease-in-out;

        &:hover {
            background-color: #e9ecef;
            border-color: #adb5bd;
        }

        .placeholder-icon {
            opacity: 0.6;
            transition: opacity 0.15s ease-in-out;
        }

        &:hover .placeholder-icon {
            opacity: 0.8;
        }
    }
}

.upload-footer {
  padding: 1rem 2rem 1.5rem 2rem;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;

  .close-btn {
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    color: #6c757d;
    padding: 0.5rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.15s ease-in-out;

    &:hover {
      background-color: #e9ecef;
      border-color: #e9ecef;
      color: #495057;
    }
  }
}

.upload-form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;

    div {
        display: flex;
        flex-direction: column;
        gap: 0;
    }
    
    p  {
        font-size: 14px;
        margin: 0;
    }

    small {
        font-size: 10px;
    }
}
</style>